<template>
    <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
        <el-form :model="formData" ref="formData" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs type="border-card" v-model="pageLangCode">
                <el-tab-pane :name="langItem.langCode" :label="$t('message.' + langItem.langCode)"
                    v-for="(langItem, index) in langMap" :key="index">
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">Event Name </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="formData[langItem.keyName]">
                                        <el-input disabled v-model="formData[langItem.keyName]" :name="formData[langItem.keyName]"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Contact Name </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="contactName">
                                        <el-input disabled v-model="formData.contactName" name="contactName"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Comment </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="content">
                                        <el-input disabled v-model="formData.content" :name="'content'" type="textarea"
                                            :rows="8" />
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Member No </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="memberNo">
                                        <el-input disabled v-model="formData.memberNo" name="memberNo"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Contact No </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="contactNo">
                                        <el-input disabled v-model="formData.contactNo" name="contactNo"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Email</label>
                                <div class="col-sm-10">
                                    <el-form-item prop="memberNo">
                                        <el-input disabled v-model="formData.email" name="email"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Type
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="messageType">
                                        <el-select disabled v-model="formData.messageType" placeholder="Search Type"
                                            name="messageType" clearable filterable>
                                            <el-option v-for="item in messageTypeList" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Sub-Type
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="generalType">
                                        <el-select disabled style="width: 200px !important" v-model="formData.generalType"
                                            :name="'generalType'">
                                            <el-option v-for="item in generalTypeList" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label"> District </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="message">
                                        <el-select disabled v-model="formData.districtCode" placeholder="Search district"
                                            name="eventDistrictCode" clearable filterable>
                                            <el-option v-for="item in districtGetlist" :key="item.districtCode"
                                                :label="item.districtNameEn" :value="item.districtCode">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Overall Rating</label>
                                <div class="col-sm-10">
                                    <el-form-item prop="answerOne">
                                        <el-input disabled v-model="formData.answerOne" name="answerOne"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">Channel</label>
                                <div class="col-sm-10">
                                    <el-form-item prop="answerTwo">
                                        <el-input disabled v-model="formData.answerTwo" name="answerTwo"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Created At </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="createdAt">
                                        <el-input disabled style="width: 300px" v-model="formData.createdAt"
                                            :name="'createdAt'" maxLength="50" />
                                    </el-form-item>
                                </div>
                            </div>

                            <el-divider></el-divider>

                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Status </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="status">
                                        <div class="status-wrap">
                                            <el-select style="width: 200px !important" v-model="formData.status"
                                                :name="'status'">
                                                <el-option v-for=" item  in  statusList " :key="item.value"
                                                    :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label"> My Notes </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="sloNote">
                                        <el-input type="textarea" :rows="3" v-model="formData.notes" :name="'sloNote'" />
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <!-- TODO -->
                                        <el-button type="primary" v-if="(
                                            $route.query.id)
                                            " @click="checkEvent()">
                                            {{ $t("message.Save") }}
                                        </el-button>
                                        <el-button @click="showWarning()">
                                            {{ $t("message.Cancel") }}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</template>
<script>
import config from "../config";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            formData: {
                contactNo: '',
                content: '',
                createdAt: '',
                districtCode: '',
                eventCode: '',
                eventName: '',
                generalType: '',
                memberId: '',
                memberNo: '',
                messageType: '',
                notes: '',
                status: ''
            },
            districtGetlist: [],
            pageLangCode:'en_US'
        };
    },
    computed: {
        messageTypeMap() {
            return {
                1: 'General',
                2: 'Event'
            }
        },
        messageTypeList() {
            return [
                { label: "General", value: 1 },
                { label: "Event", value: 2 },
            ]
        },
        statusMap() {
            return {
                0: "Submitted",
                1: "Closed"
            }
        },
        statusList() {
            return [
                { label: "Submitted", value: 0 },
                { label: "Closed", value: 1 },
            ]
        },
        generalTypeeMap() {
            return {
                0: "Member Login Enquiry",
                1: "Event Enquiry",
                2: "Redemption Enquiry",
                3: "Others",
            }
        },
        generalTypeList() {
            return [
                { label: "Member Login Enquiry", value: 0 },
                { label: "Event Enquiry", value: 1 },
                { label: "Redemption Enquiry", value: 2 },
                { label: "Others", value: 3 },
            ]
        },
        userInfo() {
            return this.getAuthObj();
        },
        langMap() {
            return [
                { langCode: 'en_US', keyName: 'eventName' },
                { langCode: 'zh_HK', keyName: 'eventNameHk' },
                { langCode: 'zh_CN', keyName: 'eventNameCn' },
            ]
        }
    },
    created() {
        this.getDistrictGetlist()
        this.init();
    },
    mounted() { },
    methods: {
        async init() {
            let id = Number(this.$route.query.id);
            if (id) {
                const params = {
                    ...this.userInfo,
                    id,
                    apiUrl: this.apiConfig.memberCommentBoxDetail,
                };

                let data = await this.$store.dispatch("apiEvent", params);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                this.formData = data.data.result;
            }
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
            }
        },
        checkEvent() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submit();
                } else {
                    return false;
                }
            });
        },
        async submit() {
            const params = {
                status: this.formData.status,
                notes: this.formData.notes,
                id: Number(this.$route.query.id),
                ...this.userInfo,
                apiUrl: this.apiConfig.memberCommentBoxUpdate,
            };
            var data;
            data = await this.$store.dispatch("apiEvent", params);

            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            if (data.data.status_code === "0") {
                this.$router.go(-1);
            }
        },
        async getDistrictGetlist() {
            let obj = this.getAuthObj();
            obj.apiUrl = this.apiConfig.districtGetlist;
            let data = await this.$store.dispatch("apiEvent", obj);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.$set(this, "districtGetlist", data.data.result);
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
    max-width: 600px;
}

::v-deep .el-textarea {
    max-width: 600px;
}

::v-deep .el-textarea__inner {
    color: #606266 !important;
}
</style>